export interface ServiceMode {
  code: string;
  label: string;
}

// Order matches the source system's mode dropdown
export const SERVICE_MODES: ServiceMode[] = [
  { code: "0009", label: "Tbills" },
  { code: "0010", label: "Fixed deposits" },
  { code: "0001", label: "Account Opening" },
  { code: "0011", label: "Loan Application" },
  { code: "0005", label: "Counter Cheque" },
  { code: "0006", label: "Bank Statement" },
  { code: "0002", label: "Remittance" },
  { code: "0003", label: "3rd Party Withdrawal" },
  { code: "0004", label: "3rd Party Deposit" },
  { code: "0007", label: "Customer Update" },
  { code: "0008", label: "Mastercard Request" },
  { code: "0012", label: "ACH / SWIFT" },
  { code: "0013", label: "Bank Transfer" },
];

export const getServiceModeLabel = (code?: string | null): string =>
  SERVICE_MODES.find((m) => m.code === code)?.label || "";
